import { render, staticRenderFns } from "./modalTranslateOptIns.vue?vue&type=template&id=661bf8aa&"
import script from "./modalTranslateOptIns.vue?vue&type=script&lang=js&"
export * from "./modalTranslateOptIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports